/* tslint:disable */
/* eslint-disable */
/* @relayHash b1ef58f74480d9a60869e39414253b65 */

import { ConcreteRequest } from "relay-runtime";
export type mutationsSubmitEntriesMutationVariables = {
    supervisorID?: string | null;
    mentorID?: string | null;
    entries: Array<string>;
    title?: string | null;
};
export type mutationsSubmitEntriesMutationResponse = {
    readonly submitEntries: boolean;
};
export type mutationsSubmitEntriesMutation = {
    readonly response: mutationsSubmitEntriesMutationResponse;
    readonly variables: mutationsSubmitEntriesMutationVariables;
};



/*
mutation mutationsSubmitEntriesMutation(
  $supervisorID: ID
  $mentorID: ID
  $entries: [ID!]!
  $title: String
) {
  submitEntries(input: {supervisorID: $supervisorID, mentorID: $mentorID, entries: $entries, title: $title})
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "supervisorID",
            "type": "ID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "mentorID",
            "type": "ID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "entries",
            "type": "[ID!]!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "title",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "submitEntries",
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "entries",
                            "variableName": "entries"
                        },
                        {
                            "kind": "Variable",
                            "name": "mentorID",
                            "variableName": "mentorID"
                        },
                        {
                            "kind": "Variable",
                            "name": "supervisorID",
                            "variableName": "supervisorID"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        }
                    ]
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "mutationsSubmitEntriesMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "mutationsSubmitEntriesMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "mutationsSubmitEntriesMutation",
            "id": null,
            "text": "mutation mutationsSubmitEntriesMutation(\n  $supervisorID: ID\n  $mentorID: ID\n  $entries: [ID!]!\n  $title: String\n) {\n  submitEntries(input: {supervisorID: $supervisorID, mentorID: $mentorID, entries: $entries, title: $title})\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'dd0294f4c306c1ca4ce086aef77a6cad';
export default node;
